import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import HubDetailSBSExpandable from '../SBSTable/HubDetailSBSExpandable';

import { useGetHubDMCTTableColumns } from './useGetHubDMCTTableColumns';

import { TrapData } from 'api/traps/Hubs/types';
import FilterDataTable from 'components/FilterDataTable/FilterDataTable';
import useScreenSize from 'hooks/Screen/useScreenSize';
import MultiCatchMouseTrapIcon from 'components/Icons/MultiCatchMouseTrapIcon';
import { TrapType } from 'components/AnalyticsPage/TrapType';
import SnapTrapMouseIcon from 'components/Icons/SnapTrapMouseIcon';
import SnapTrapRatIcon from 'components/Icons/SnapTrapRatIcon';
import { TrapTableTypeLink } from 'components/TrapsTables/trapTables';

interface HubDetailTrapTableProps {
  data: TrapData[];
  trapType: TrapType;
  isLoading: boolean;
  slug: string;
  refetch: () => void;
  deviceType?: TrapTableTypeLink;
}

const HubDetailTrapTable: React.FC<HubDetailTrapTableProps> = ({
  data,
  trapType,
  isLoading,
  refetch,
  slug,
  deviceType,
}) => {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const columns = useGetHubDMCTTableColumns(slug, trapType, deviceType || TrapTableTypeLink.Hubs);
  const { isNotMobile } = useScreenSize();
  const { t } = useTranslation();

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <div className="bg-white">
      <FilterDataTable<TrapData>
        columns={columns}
        data={data || []}
        onChangePage={setPage}
        title={
          trapType === TrapType.MCT
            ? t('HubDetail.traps.MCTTitle')
            : trapType === TrapType.SMST
              ? t('HubDetail.traps.SMSTTitle')
              : t('HubDetail.traps.SRSTTitle')
        }
        iconComponent={
          trapType === TrapType.MCT ? (
            <MultiCatchMouseTrapIcon />
          ) : trapType === TrapType.SMST ? (
            <SnapTrapMouseIcon />
          ) : (
            <SnapTrapRatIcon />
          )
        }
        onChangeFilterParams={setQueryParam}
        onChangeSearch={setSearch}
        isLoading={isLoading}
        expandableRows={isNotMobile}
        expandableRowsComponent={row => <HubDetailSBSExpandable data={row.data} slug={slug} deviceType={deviceType} />}
      />
    </div>
  );
};

export default HubDetailTrapTable;
